import React from 'react';
import {Grid} from '@mui/material';
import clsx from 'clsx';
import makeStyles from '@mui/styles/makeStyles';
import AssessmentsFolders from './assessmentsFolders';
import AssessmentView from './assessmentView';

const useStyles = makeStyles((theme) => ({
    root: {
        overflowY: 'hidden',
        padding: 5,
        height: '100%',
    },
    container: {
        paddingRight: 5,
        overflowY: 'auto',
        overflowX: 'hidden',
        height: '100%',
    },
    accDetails: {
        borderTop: '1px solid ' + theme.palette.divider,
    },
    accordionTitle: {
        fontSize: '1.2rem',
        fontWeight: '600',
    },
    accordionSecondLabelContainer: {
        display: 'flex',
        alignItems: 'center',
        marginLeft: 10,
    },
    accordionSecondLabel: {
        marginRight: 5,
        borderRadius: 7,
        padding: '3px 10px',
        // backgroundColor: 'black',
        backgroundColor: theme.palette.background.paper,
        color: theme.palette.mode === 'dark' ? theme.palette.text.primary : theme.palette.text.secondary,
    },
    searchField: {
        marginTop: 6,
        marginBottom: 8,
        marginRight: 5,
    },
    searchText: {
        height: 18,
    },
}));

const AssessmentList = ({patient, disableSave}) => {
    const classes = useStyles();

    return (
        <Grid container spacing={2} sx={{height: '100%'}} className={classes.root}>
            <Grid
                item
                xs={3}
                className={clsx(classes.container, 'scroll-normal-white')}
                style={{paddingTop: 0}}
            >
                <AssessmentsFolders disableSave={disableSave} patient={patient}/>
            </Grid>

            <Grid
                item xs={9}
                className={clsx(classes.container, 'scroll-normal-white')}
                style={{paddingTop: 0, paddingBottom: 80}}
            >
                <AssessmentView patient={patient} disableSave={disableSave}/>
            </Grid>
        </Grid>
    );
};

export default AssessmentList;